import api, { setAuthTokens, clearAuthTokens } from './api'
import type { LoginRequest, PortalLoginRequest, AuthResponse, RefreshTokenRequest, User } from '@/types/auth.types'
import type { ApiResponse } from '@/types/api.types'

export const authService = {
  async login(request: LoginRequest): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/login', request)
    return response.data
  },

  async portalLogin(request: PortalLoginRequest): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/portal-login', request)
    return response.data
  },

  async refreshToken(request: RefreshTokenRequest): Promise<ApiResponse<any>> {
    const response = await api.post('/auth/refresh', request)
    return response.data
  },

  async me(): Promise<ApiResponse<User>> {
    const response = await api.get('/auth/me')
    return response.data
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout')
    } finally {
      clearAuthTokens()
    }
  },

  async forgotPassword(email: string): Promise<ApiResponse<any>> {
    const response = await api.post('/auth/forgot-password', { email })
    return response.data
  },

  async resetPassword(token: string, newPassword: string, confirmPassword: string): Promise<ApiResponse<any>> {
    const response = await api.post('/auth/reset-password', {
      token,
      newPassword,
      confirmPassword
    })
    return response.data
  },

  async changePassword(newPassword: string, confirmPassword: string): Promise<ApiResponse<any>> {
    const response = await api.post('/auth/change-password', {
      newPassword,
      confirmPassword
    })
    return response.data
  },

  setAuthTokens,
  clearAuthTokens
}
